import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=553e35a9&"
import script from "./MyProjects.vue?vue&type=script&lang=js&"
export * from "./MyProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports